class BIWSection {
  constructor(sectionEl, data) {
    this.sectionEl = sectionEl;
    this.data = data;
    this.gridEl = sectionEl.querySelector('.biw-section__grid');
    this._bindEvents();
  }

  static escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  _buildCardsHTML(cards) {
    return cards.map(card => {
      var html = '<div class="biw-card">';
      if (card.image) {
        html +=
          '<div class="biw-card__image-wrap">' +
          '<img class="biw-card__image" src="' +
          BIWSection.escapeHtml(card.image) +
          '" alt="' +
          BIWSection.escapeHtml(card.title || '') +
          '" loading="lazy" width="200" height="200">' +
          '</div>';
      }
      if (card.title) {
        html += '<p class="biw-card__title">' + BIWSection.escapeHtml(card.title) + '</p>';
      }
      if (card.subtitle) {
        html += '<p class="biw-card__subtitle">' + BIWSection.escapeHtml(card.subtitle) + '</p>';
      }
      html += '</div>';
      return html;
    }).join('');
  }

  update(variantId) {
    var vData = this.data.variants && this.data.variants[String(variantId)];
    var cards = vData && vData.cards && vData.cards.length ? vData.cards : null;

    if (!this.gridEl) return;

    if (cards) {
      this.gridEl.innerHTML = this._buildCardsHTML(cards);
      this.sectionEl.classList.remove('biw-no-data');
    } else {
      this.gridEl.innerHTML = '';
      this.sectionEl.classList.add('biw-no-data');
    }
  }

  _bindEvents() {
    document.addEventListener('variant-change', e => {
      if (e.detail && e.detail.variant && e.detail.variant.id) {
        this.update(String(e.detail.variant.id));
      }
    });

    document.body.addEventListener('change', e => {
      var t = e.target;
      if (
        t &&
        t.name === 'id' &&
        t.form &&
        String(t.form.id || '').indexOf('product-form-') === 0
      ) {
        this.update(t.value);
      }
    });
  }

  static init() {
    document.querySelectorAll('[data-biw-section]').forEach(sectionEl => {
      var sectionId = sectionEl.getAttribute('data-section-id');
      if (!sectionId) return;

      var scriptEl = document.getElementById('biw-data-' + sectionId);
      if (!scriptEl) return;

      var data;
      try {
        data = JSON.parse(scriptEl.textContent);
      } catch (e) {
        return;
      }

      new BIWSection(sectionEl, data);
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', BIWSection.init);
} else {
  BIWSection.init();
}
